// NOTE: Some icon mappings are controlled in the _getIcon function inside ForceGraph/index.tsx file.
// import aws_guardduty from '@assets/img/aws_services/aws-guardduty.svg';
import gcp_gke from '@assets/img/gcp-service-icons/gke_on-prem.svg';
import secret_manager_rounded from '@assets/img/gcp-service-icons/Secret_manager_rounded.svg';
import certificate_manager_rounded from '@assets/img/gcp-service-icons/Certificate_manager_Rounded.svg';
import gcp_iam from '@assets/img/gcp-service-icons/GCP.IAM.svg';
import gcp_big_query from '@assets/img/gcp-service-icons/GCP.BIG_QUERY.svg';
import cloud_monitoring from '@assets/img/gcp-service-icons/Cloud_Monitoring_Rounded.svg';
import azure_monitor from '@assets/img/azure_services/azure_monitor.png';
import gcp_compute_engine from '@assets/img/gcp-service-icons/GCP.COMPUTE_ENGINE.svg';
import gcp_api_gateway from '@assets/img/gcp-service-icons/api-gateway.svg';


const ICONS = {
  'AWS.ACM.Certificate': '/images/visualizer/resource-icons/AWS.ACM.Certificate.svg',
  ACMPCA: '/images/visualizer/resource-icons/ACMPCA.svg',
  'AWS.ACMPCA.CertificateAuthority': '/images/visualizer/resource-icons/AWS.ACMPCA.CertificateAuthority.svg',
  'AWS.AccessAnalyzer.Analyzer': '/images/visualizer/resource-icons/AWS.AccessAnalyzer.Analyzer.svg',
  'AWS.ApiGateway.RestApi': '/images/visualizer/resource-icons/AWS.ApiGateway.RestApi.svg',
  'AWS.ApiGateway.StageResource': '/images/visualizer/resource-icons/AWS.ApiGateway.RestApi.svg',
  'AWS.ApiGatewayv2': '/images/visualizer/resource-icons/AWS.ApiGateway.ApiAccount.svg',
  'AWS.ApiGatewayv2.ApiAccount': '/images/visualizer/resource-icons/AWS.ApiGateway.ApiAccount.svg',
  'AWS.Athena.QueryExecutions': '/images/visualizer/resource-icons/AWS.Athena.QueryExecutions.svg',
  'AWS.Athena.WorkGroups': '/images/visualizer/resource-icons/AWS.Athena.WorkGroups.svg',
  'AWS.AutoScaling.AutoScalingGroup': '/images/visualizer/resource-icons/AWS.AutoScaling.AutoScalingGroup.svg',
  'AWS.Backup.Plan': '/images/visualizer/resource-icons/AWS.Backup.Plan.svg',
  'AWS.Backup.Vault': '/images/visualizer/resource-icons/AWS.Backup.Vault.svg',
  'AWS.CloudFormation.Stack': '/images/visualizer/resource-icons/AWS.CloudFormation.Stack.svg',
  'AWS.CloudFront.Distribution': '/images/visualizer/resource-icons/AWS.CloudFront.Distribution.svg',
  'AWS.CodeBuild.BuildProject': '/images/visualizer/resource-icons/AWS.CodeBuild.BuildProject.svg',
  'AWS.IdentityCenter.Instance': '/images/visualizer/service-icons/AWS_Identity_Center.svg',
  'AWS.IdentityCenter.Group': '/images/visualizer/resource-icons/AWS.IdentityCenter.Group.png',
  'AWS.IdentityCenter.User': '/images/visualizer/resource-icons/AWS.IdentityCenter.User.png',

  // 'AWS.CodeBuild.BuildProject': '/images/visualizer/resource-icons/AWS.CodeBuild.BuildProject.svg',
  // 'AWS.CodeBuild.BuildProject': '/images/visualizer/resource-icons/AWS.CodeBuild.BuildProject.svg',
  'AWS.CloudTrail.Trail': '/images/visualizer/service-icons/AWS_CLOUDTRAIL.svg',
  'AWS.CloudWatch.Alarm': '/images/visualizer/resource-icons/AWS.CloudWatch.Alarm.svg',
  'AWS.CloudWatchEvents.Rule': '/images/visualizer/resource-icons/AWS.CloudWatchEvents.Rule.svg',
  'AWS.CloudWatchLogs.LogGroup': '/images/visualizer/resource-icons/AWS.CloudWatchLogs.LogGroup.svg',
  'AWS.Cognito.UserPool': '/images/visualizer/resource-icons/AWS.Cognito.UserPool.svg',
  'AWS.DAX.Cluster': '/images/visualizer/resource-icons/AWS.DAX.Cluster.svg',
  'AWS.DirectConnect.Connections': '/images/visualizer/resource-icons/AWS.Direct.Connect.Connections.svg',
  'AWS.ApiGatewayv2.ApiAccounts': '/images/visualizer/resource-icons/AWS.ApiGateway.ApiAccount.svg',
  'AWS.AppSync.GraphQLApi': '/images/visualizer/resource-icons/AWS.AppSync.GraphQLApi.svg',
  'AWS.DynamoDB.Table': '/images/visualizer/resource-icons/AWS.DynamoDB.Table.svg',
  'AWS.DocDB.Cluster': '/images/visualizer/resource-icons/AWS.DocDB.Cluster.svg',
  'AWS.DMS.Endpoint': '/images/visualizer/resource-icons/AWS.DMS.Endpoint.svg',
  'AWS.DMS.ReplicationTask': '/images/visualizer/resource-icons/AWS_DMS.svg',
  'AWS.DMS.ReplicationInstance': '/images/visualizer/resource-icons/AWS_DMS.svg',
  'AWS.DynamoDB.GlobalSecondaryIndex': '/images/visualizer/resource-icons/AWS.DynamoDB.Table.svg',
  'AWS.EC2.AccountAttributes': '/images/visualizer/resource-icons/AWS.EC2.AccountAttributes.svg',
  'AWS.EC2.Ami': '/images/visualizer/resource-icons/AWS.EC2.Ami.svg',
  'AWS.EC2.EgressOnlyInternetGateway': '/images/visualizer/resource-icons/AWS.EC2.EgressOnlyInternetGateway.svg',
  'AWS.EC2.EIP': '/images/visualizer/resource-icons/AWS.EC2.EIP.svg',
  'AWS.EC2.FlowLog': '/images/visualizer/resource-icons/AWS.EC2.FlowLog.svg',
  'AWS.EC2.Instance': '/images/visualizer/resource-icons/AWS.EC2.Instance.svg',
  'AWS.EC2.InternetGateway': '/images/visualizer/resource-icons/AWS.EC2.InternetGateway.svg',
  'AWS.EC2.KeyPair': '/images/visualizer/resource-icons/AWS.EC2.KeyPair.svg',
  'AWS.EC2.NATGateway': '/images/visualizer/resource-icons/AWS.EC2.NATGateway.svg',
  'AWS.EC2.NATZones': '/images/visualizer/resource-icons/AWS.EC2.NATZones.svg',
  'AWS.EC2.NetworkACL': '/images/visualizer/resource-icons/AWS.EC2.NetworkACL.svg',
  'AWS.EC2.NetworkInterface': '/images/visualizer/resource-icons/AWS.EC2.NetworkInterface.svg',
  'AWS.EC2.RouteTable': '/images/visualizer/resource-icons/AWS.EC2.RouteTable.svg',
  'AWS.EC2.SecurityGroup': '/images/visualizer/resource-icons/AWS.EC2.SecurityGroup.svg',
  'AWS.EC2.Snapshot': '/images/visualizer/resource-icons/AWS.EC2.Snapshot.svg',
  'AWS.EC2.Subnet': '/images/visualizer/resource-icons/AWS.EC2.VPC.svg',
  'AWS.EC2.Volume': '/images/visualizer/resource-icons/AWS.EC2.Volume.svg',
  'AWS.EC2.VPC': '/images/visualizer/resource-icons/AWS.EC2.VPC.svg',
  'AWS.EC2.Vpc': '/images/visualizer/resource-icons/AWS.EC2.VPC.svg',
  'AWS.EC2.VPCEndpoint': '/images/visualizer/resource-icons/AWS.EC2.VPCEndpoint.svg',
  'AWS.EC2.Vpc_Ipv4CidrBlock': '/images/visualizer/resource-icons/AWS.EC2.VPC.svg',
  'AWS.EC2.VpcEndpoint': '/images/visualizer/resource-icons/AWS.EC2.VPCEndpoint.svg',
  'AWS.EC2.VpcPeeringConnection': '/images/visualizer/resource-icons/AWS.EC2.VPCPeeringConnection.svg',
  'AWS.EC2.VPNConnection': '/images/visualizer/resource-icons/AWS.EC2.VPNConnection.svg',
  'AWS.EC2.VpnConnection': '/images/visualizer/resource-icons/AWS.EC2.VPNConnection.svg',
  'AWS.EC2.VPNGateway': '/images/visualizer/resource-icons/AWS.EC2.VPNGateway.svg',
  'AWS.EC2.VpnGateway': '/images/visualizer/resource-icons/AWS.EC2.VPNGateway.svg',
  'AWS.ECR.Image': '/images/visualizer/service-icons/AWS_ECR.svg',
  'AWS.ECR.Repository': '/images/visualizer/resource-icons/AWS.ECR.Repository.svg',
  'AWS.ECR.RepositoryPolicy': '/images/visualizer/resource-icons/AWS.ECR.RepositoryPolicy.svg',
  'AWS.ECS.Cluster': '/images/visualizer/resource-icons/AWS.ECS.Cluster.svg',
  'AWS.ECS.ContainerInstances': '/images/visualizer/resource-icons/AWS.ECS.ContainerInstances.svg',
  'AWS.ECS.Service': '/images/visualizer/resource-icons/AWS.ECS.Service.svg',
  'AWS.EFS.FileSystem': '/images/visualizer/resource-icons/AWS.EFS.FileSystem.svg',
  'AWS.EKS.ClusterRole': '/images/visualizer/resource-icons/AWS.EKS.ClusterRole.svg',
  'AWS.EKS.Cluster': '/images/visualizer/resource-icons/Cluster.svg',
  'AWS.EKS.ClusterRoleBinding': '/images/visualizer/resource-icons/AWS.EKS.ClusterRoleBinding.svg',
  'AWS.EKS.CustomResourceDefinition': '/images/visualizer/resource-icons/AWS.EKS.CustomResourceDefinition.svg',
  'AWS.EKS.Namespace': '/images/visualizer/resource-icons/AWS.EKS.Namespace.svg',
  'AWS.EKS.PSP': '/images/visualizer/resource-icons/AWS.EKS.PSP.svg',
  'AWS.EKS.FlowSchema': '/images/visualizer/service-icons/AWS_EKS.svg',
  'AWS.EKS.User': '/images/visualizer/service-icons/AWS_EKS.svg',
  'AWS.EKS.Group': '/images/visualizer/service-icons/AWS_EKS.svg',
  'AWS.EKS.StatefulSet': '/images/visualizer/resource-icons/AWS.EKS.StatefulSet.png',
  'AWS.EKS.CSINode': '/images/visualizer/resource-icons/AWS.EKS.CSINode.png',
  'AWS.EKS.CNINode': '/images/visualizer/resource-icons/AWS.EKS.CNINode.png',
  'AWS.EKS.Pod': '/images/visualizer/resource-icons/AWS.EKS.Pod.svg',
  'AWS.EKS.RoleBinding': '/images/visualizer/resource-icons/AWS.EKS.RoleBinding.svg',
  'AWS.EKS.ConfigMap': '/images/visualizer/resource-icons/AWS.EKS.ConfigMap.svg',
  'AWS.EKS.Role': '/images/visualizer/resource-icons/AWS.EKS.Role.svg',
  'AWS.EKS.Secret': '/images/visualizer/resource-icons/AWS.EKS.Secret.svg',
  'AWS.EKS.PriorityClass': '/images/visualizer/resource-icons/AWS.EKS.Pod.svg',
  'AWS.EKS.PriorityLevelConfiguration': '/images/visualizer/resource-icons/AWS.EKS.ConfigMap.svg',
  'AWS.EKS.StorageClass': '/images/visualizer/resource-icons/AWS.EKS.StorageClass.svg',
  'AWS.EKS.ComponentStatus': '/images/visualizer/resource-icons/Cluster.svg',
  'AWS.EKS.ValidatingWebhookConfiguration': '/images/visualizer/resource-icons/AWS.EKS.ConfigMap.svg',
  'AWS.EKS.MutatingWebhookConfiguration': '/images/visualizer/resource-icons/AWS.EKS.ConfigMap.svg',
  'AWS.EKS.ControllerRevision': '/images/visualizer/resource-icons/AWS.EKS.ControllerRevision.png',
  'AWS.EKS.CSIDriver': '/images/visualizer/resource-icons/AWS.EKS.CSINode.png',
  'AWS.EKS.ServiceAccount': '/images/visualizer/resource-icons/AWS.EKS.Service.svg',
  'AWS.EKS.Service': '/images/visualizer/resource-icons/AWS.EKS.Service.svg',
  'AWS.Guardduty.Status': '/images/visualizer/service-icons/AWS_Guardduty.svg',
  'AWS.Guardduty.Finding': '/images/visualizer/service-icons/AWS_Guardduty.svg',
  'AWS.EKS.Event': '/images/visualizer/resource-icons/AWS.EKS.Event.png',
  'AWS.EKS.Lease': '/images/visualizer/resource-icons/AWS.EKS.Lease.png',
  'AWS.EKS.Endpoints': '/images/visualizer/resource-icons/AWS.EKS.Endpoints.png',
  'AWS.EKS.EndpointSlice': '/images/visualizer/resource-icons/AWS.EKS.Endpoints.png',
  'AWS.EKS.DaemonSet': '/images/visualizer/resource-icons/AWS.EKS.DaemonSet.svg',
  'AWS.EKS.NetworkPolicy': '/images/visualizer/resource-icons/AWS.EKS.NetworkPolicy.svg',
  'AWS.EKS.Deployment': '/images/visualizer/resource-icons/AWS.EKS.Deployment.svg',
  'AWS.EKS.Node': '/images/visualizer/resource-icons/Node.svg',
  'AWS.EKS.V_P_C': '/images/visualizer/resource-icons/AWS.EKS.V_P_C.png',
  'AWS.EKS.Container': '/images/visualizer/resource-icons/AWS.EKS.Container.png',
  'AWS.EKS.ReplicaSet': '/images/visualizer/resource-icons/AWS.EKS.ReplicaSet.svg',
  'AWS.EKS.CertificateSigningRequest': '/images/visualizer/resource-icons/AWS.EKS.CertificateSigningRequest.png',
  'AWS.EKS.APIService': '/images/visualizer/service-icons/AWS_EKS.svg',
  'AWS.EKS.Job':  '/images/visualizer/service-icons/AWS_EKS.svg',
  'AWS.EKS.CronJob': '/images/visualizer/service-icons/AWS_EKS.svg',
  'AWS.EKS.Image': '/images/visualizer/service-icons/AWS_EKS.svg',
  'AWS.EKS.VolumeMetrics': '/images/visualizer/resource-icons/AWS.EKS.VolumeMetrics.svg',
  'AWS.EKS.PersistentVolumeClaim': '/images/visualizer/service-icons/AWS_EKS.svg',
  'AWS.EKS.PersistentVolume': '/images/visualizer/service-icons/AWS_EKS.svg',
  'AWS.EKS.PodDisruptionBudget': '/images/visualizer/service-icons/AWS_EKS.svg',
  'AWS.Bedrock.LoggingConfiguration': '/images/visualizer/resource-icons/AWS_Bedrock_LoggingConfiguration.svg',
  'AWS.Bedrock.InferenceProfile': '/images/visualizer/resource-icons/AWS_Bedrock_InferenceProfile.svg',
  'AWS.Bedrock.Guardrail': '/images/visualizer/resource-icons/AWS_Bedrock_Guardrail.svg',
  'AWS.ElastiCache': '/images/visualizer/resource-icons/AWS.ElastiCache.svg',
  'AWS.ElastiCache.ParameterGroup': '/images/visualizer/resource-icons/AWS.ElastiCache.ParameterGroup.svg',
  'AWS.ElasticBeanstalk.Configuration': '/images/visualizer/resource-icons/AWS.ElasticBeanstalk.Configuration.svg',
  'AWS.ElasticBeanstalk.Environment': '/images/visualizer/resource-icons/AWS.ElasticBeanstalk.Environment.svg',
  'AWS.ELB.LoadBalancer': '/images/visualizer/resource-icons/AWS.ELB.LoadBalancer.svg',
  'AWS.ELB.Policy': '/images/visualizer/resource-icons/AWS.ELB.Policy.svg',
  'AWS.ELBv2.LoadBalancer': '/images/visualizer/resource-icons/AWS.ELBv2.LoadBalancer.svg',
  'AWS.ELBv2.Listener': '/images/visualizer/resource-icons/AWS.ELBv2.LoadBalancer.svg',
  'AWS.ELB.Listener': '/images/visualizer/resource-icons/AWS.ELBv2.LoadBalancer.svg',
  'AWS.EMR.Cluster': '/images/visualizer/resource-icons/AWS.EMR.Cluster.svg',
  'AWS.Events.EventBus': '/images/visualizer/resource-icons/AWS.Events.EventBus.svg',
  'AWS.Glue.DataCatalogEncryptionSettings':
    '/images/visualizer/resource-icons/AWS.Glue.DataCatalogEncryptionSettings.svg',
  'AWS.Glue.SecurityConfiguration': '/images/visualizer/resource-icons/AWS.Glue.SecurityConfiguration.svg',
  'AWS.IAM.AccountPasswordPolicy': '/images/visualizer/resource-icons/AWS.IAM.AccountPasswordPolicy.svg',
  'AWS.IAM.CredentialReport': '/images/visualizer/resource-icons/AWS.IAM.CredentialReport.svg',
  'AWS.IAM.RootCredentialReport': '/images/visualizer/resource-icons/AWS.IAM.CredentialReport.svg',
  'AWS.IAM.Group': '/images/visualizer/resource-icons/AWS.IAM.Group.svg',
  'AWS.IAM.Policy': '/images/visualizer/resource-icons/AWS.IAM.Policy.svg',
  'AWS.IAM.Role': '/images/visualizer/resource-icons/AWS.IAM.Role.svg',
  'AWS.IAM.SAMLProvider': '/images/visualizer/resource-icons/AWS.IAM.SAMLProvider.svg',
  'AWS.IAM.ServerCertificate': '/images/visualizer/resource-icons/AWS.IAM.ServerCertificate.svg',
  'AWS.IAM.SupportPolicy': '/images/visualizer/resource-icons/AWS.IAM.SupportPolicy.svg',
  'AWS.IAM.User': '/images/visualizer/resource-icons/AWS.IAM.User.svg',
  'AWS.Kinesis.Stream': '/images/visualizer/resource-icons/AWS.Kinesis.Stream.svg',
  'AWS.KMS.Alias': '/images/visualizer/resource-icons/AWS.KMS.Key.svg',
  'AWS.KMS.Key': '/images/visualizer/resource-icons/AWS.KMS.Key.svg',
  'AWS.KMS.Grant': '/images/visualizer/resource-icons/AWS.KMS.Key.svg',
  'AWS.Lambda.Function': '/images/visualizer/resource-icons/AWS.Lambda.Function.svg',
  'AWS.Logs.MetricFilter': '/images/visualizer/resource-icons/AWS.Logs.MetricFilter.svg',
  'AWS.NetworkFirewall.Firewall': '/images/visualizer/resource-icons/AWS_NETWORKFIREWALL.svg',
  'AWS.NetworkFirewall.FirewallPolicy': '/images/visualizer/resource-icons/AWS_NETWORKFIREWALL.svg',
  'AWS.NetworkFirewall.FirewallLoggingConfiguration': '/images/visualizer/resource-icons/AWS_NETWORKFIREWALL.svg',
  'AWS.Neptune.DBInstance': '/images/visualizer/resource-icons/AWS.Neptune.DBInstance.svg',
  'AWS.Neptune.Dbinstance': '/images/visualizer/resource-icons/AWS.Neptune.DBInstance.svg',
  'AWS.Neptune.Snapshot': '/images/visualizer/resource-icons/AWS.Neptune.Snapshot.svg',
  'AWS.OpenSearch.Domain': '/images/visualizer/resource-icons/AWS.OpenSearch.Domain.svg',
  'AWS.Organizations.Organization': '/images/visualizer/resource-icons/AWS_ORGANISATION.svg',
  'AWS.Organizations.Account': '/images/visualizer/resource-icons/AWS.Organizations.Account.svg',
  'AWS.RDS.Cluster': '/images/visualizer/resource-icons/AWS.RDS.Cluster.svg',
  'AWS.RDS.DBSubnetGroup': '/images/visualizer/resource-icons/AWS.RDS.Cluster.svg',
  'AWS.RDS.Event': '/images/visualizer/resource-icons/AWS.RDS.Event.svg',
  'AWS.RDS.EventSubscription': '/images/visualizer/resource-icons/AWS.RDS.EventSubscription.svg',
  'AWS.RDS.Instance': '/images/visualizer/resource-icons/AWS.RDS.Instance.svg',
  'AWS.RDS.ReservedInstance': '/images/visualizer/resource-icons/AWS.RDS.ReservedInstance.svg',
  'AWS.RDS.Snapshot': '/images/visualizer/resource-icons/AWS.RDS.Snapshot.svg',
  'AWS.NetworkFirewall.FirewallRuleGroup': '/images/visualizer/resource-icons/AWS.NetworkFirewall.FirewallRuleGroup.svg',
  'AWS.Redshift.Cluster': '/images/visualizer/resource-icons/AWS.Redshift.Cluster.svg',
  'AWS.Redshift.ParameterGroup': '/images/visualizer/resource-icons/AWS.Redshift.ParameterGroup.svg',
  'AWS.Route53.Domains': '/images/visualizer/resource-icons/AWS.Route53.Domains.svg',
  'AWS.Route53.DNSRecord': '/images/visualizer/resource-icons/AWS.Route53.Domains.svg',
  'AWS.Route53.HostedZone': '/images/visualizer/resource-icons/AWS.Route53.HostedZone.svg',
  'AWS.S3.Bucket': '/images/visualizer/service-icons/AWS_S3.svg',
  'AWS.S3.PublicAccessBlockConfiguration': '/images/visualizer/service-icons/AWS_S3.svg',
  'AWS.Sagemaker.NotebookInstance': '/images/visualizer/resource-icons/AWS.Sagemaker.NotebookInstance.svg',
  'AWS.SecretsManager.Secret': '/images/visualizer/resource-icons/AWS.SecretsManager.Secret.svg',
  'AWS.Serverless.ApiGateway.RestApi': '/images/visualizer/resource-icons/AWS.Serverless.ApiGateway.RestApi.svg',
  'AWS.Serverless.Lambda.Function': '/images/visualizer/resource-icons/AWS.Serverless.Lambda.Function.svg',
  'AWS.Serverless.SFN.StateMachine': '/images/visualizer/resource-icons/AWS.Serverless.SFN.StateMachine.svg',
  'AWS.SNS.Topic': '/images/visualizer/resource-icons/AWS.SNS.Topic.svg',
  'AWS.SFN.StateMachine': '/images/visualizer/resource-icons/AWS.SFN.StateMachine.svg',
  'AWS.SQS.Queue': '/images/visualizer/resource-icons/AWS.SQS.Queue.svg',
  'AWS.EC2.Reservation': '/images/visualizer/resource-icons/AWS.EC2.Reservation.svg',
  'AWS.IAM.Policystatement': '/images/visualizer/resource-icons/AWS.IAM.Policystatement.svg',
  'AWS.IAM.Accesskey': '/images/visualizer/resource-icons/AWS.IAM.accesskey.svg',
  'AWS.WAF.WebACL': '/images/visualizer/resource-icons/AWS_WAF.svg',
  'AWS.WAFv2.WebACL': '/images/visualizer/resource-icons/AWS_WAF.svg',
  'AWS.SSM.Association': '/images/visualizer/resource-icons/AWS.SSM.Association.svg',
  'AWS.SES.Identities': '/images/visualizer/service-icons/AWS_SES.svg',
  'AWS SSM': '/images/visualizer/resource-icons/AWS.SSM.Association.svg',
  Rule: '/images/visualizer/resource-icons/JSON.svg', // It's a Problem.
  'Rule.Regular': '/images/visualizer/resource-icons/Misconfiguration.svg', // It's a Problem.
  'Rule.Vulnerabilities': '/images/visualizer/resource-icons/Vulnerability.svg', // It's a Problem
  'Vulnerability.CVE': '/images/visualizer/resource-icons/Vulnerability.svg', // It's a Problem
  'Anomaly ': '/images/visualizer/resource-icons/Anomaly.svg', // It's a Problem
  Threat: '/images/visualizer/resource-icons/Threat.svg', // It's a Problem
  Anomalous: '/images/visualizer/resource-icons/Anomaly.svg', // It's a Problem
  'Rule.Threat': '/images/visualizer/resource-icons/Threat.svg', // It's a Problem
  'Rule.Anomalous': '/images/visualizer/resource-icons/Anomaly.svg',
  Internet: '/images/visualizer/resource-icons/Internet_Exposed_Icon.svg',
  'Rule.Internet exposed': '/images/visualizer/resource-icons/Internet_Exposed_Icon.svg',
  'Identity.Access': '/images/visualizer/resource-icons/Identity.AccessTo.svg',
  'Identity.Expose': '/images/visualizer/resource-icons/Identity.ExposedTo.svg',
  PII: '/images/visualizer/resource-icons/PII.svg',
  PHI: '/images/visualizer/resource-icons/PHI.svg',
  PCI: '/images/visualizer/resource-icons/PCI.svg',

  Secrets: '/images/visualizer/resource-icons/Secrets.svg', // It's a Problem
  'Risk.Attack_Path': '/images/visualizer/resource-icons/AttackPath.svg', // It's a Problem
  AttackPath: '/images/visualizer/resource-icons/AttackPath.svg', // It's a Problem
  'crown-red': '/images/visualizer/tools/gem-icon.svg',
  'crown-icon': '/images/visualizer/tools/crown-icon.svg',
  'gem-icon': '/images/visualizer/tools/crown-icon.svg',
  Attacker: '/images/visualizer/actor.png',
  // GCP Icons
  'GCP.GCE.Firewall': '/images/visualizer/resource-icons/GCP.GCE.FIREWALL_RULES.svg',
  'GCP.GCE.Subnetwork': '/images/visualizer/resource-icons/GCP.GCE.SUBNETWORK.svg',
  'GCP.GCE.SubNetwork': '/images/visualizer/resource-icons/GCP.GCE.SUBNETWORK.svg',
  'GCP.GCE.VPC': '/images/visualizer/resource-icons/GCP.GCE.VPC.svg',
  'GCP.GCE.INSTANCE': '/images/visualizer/resource-icons/GCP.COMPUTE_ENGINE.svg',
  'GCP.GCE.Instance': '/images/visualizer/resource-icons/GCP.COMPUTE_ENGINE.svg',
  'GCP.GCE.InternetGateway': gcp_compute_engine,
  'GCP.IAM.Policy': gcp_iam,
  'GCP.IAM.ServiceAccount': gcp_iam,
  'GCP.IAM.BindingSeparationDuties': gcp_iam,
  'GCP.IAM.Domain': gcp_iam,
  'GCP.IAM.User': gcp_iam,
  'GCP.IAM.Group': gcp_iam,
  'GCP.IAM.Role': gcp_iam,
  'GCP.IAM.Approval': gcp_iam,
  'GCP.STO.Bucket': '/images/visualizer/resource-icons/GCP.CLOUD_STORAGE.svg',
  'GCP.GCE.VPc': '/images/visualizer/resource-icons/GCP.GCE.VPC.svg',
  'GCP.GKE.Cluster': '/images/visualizer/resource-icons/GCP.KUBERNETES_ENGINE.svg',
  'GCP.GKE.Node': '/images/visualizer/resource-icons/GCP.KUBERNETES_ENGINE.svg',
  'GCP.GCFv2.Function': '/images/visualizer/resource-icons/GCP.CLOUD_FUNCTION.svg',
  'GCP.GCFv1.Function': '/images/visualizer/resource-icons/GCP.CLOUD_FUNCTION.svg',
  'GCP.CLO.MetricFilter': '/images/visualizer/resource-icons/GCP.CLOUD_LOGGING.svg',
  'GCP.CLO.Sink': '/images/visualizer/resource-icons/GCP.CLOUD_LOGGING.svg',
  'GCP.CLO.AuditLog': '/images/visualizer/resource-icons/GCP.CLO.AUDIT_LOG.svg',
  'GCP.BQ.Dataset': gcp_big_query,
  'GCP.BQ.Table': gcp_big_query,
  'GCP.GCE.Snapshot': '/images/visualizer/resource-icons/GCP.COMPUTE_ENGINE.svg',
  'GCP.GCE.MachineType': '/images/visualizer/resource-icons/GCP.COMPUTE_ENGINE.svg',
  'GCP.GCE.Region': '/images/visualizer/resource-icons/GCP.COMPUTE_ENGINE.svg',
  'GCP.GCE.Zone': '/images/visualizer/resource-icons/GCP.COMPUTE_ENGINE.svg',
  'GCP.GCE.Disk': '/images/visualizer/resource-icons/GCP.GCE.DISK.svg',
  'GCP.GCE.Firewal': '/images/visualizer/resource-icons/GCP.GCE.FIREWALL_RULES.svg',
  'GCP.GCE.Network': '/images/visualizer/resource-icons/GCP.GCE.NETWORK.svg',
  'GCP.KMS.KeyRing': '/images/visualizer/resource-icons/GCP.KMS.svg',
  'GCP.KMS.Keys': '/images/visualizer/resource-icons/GCP.KMS.svg',
  'GCP.KMS.Key': '/images/visualizer/resource-icons/GCP.KMS.svg',
  'GCP.KMS.Policy': '/images/visualizer/resource-icons/GCP.KMS.svg',
  'GCP.CLB.LoadBalancer': '/images/visualizer/resource-icons/GCP.CLOUD_LOAD_BALANCING.svg',
  'GCP.CLB.Backend': '/images/visualizer/resource-icons/GCP.CLOUD_LOAD_BALANCING.svg',
  'GCP.CLB.Frontend': '/images/visualizer/resource-icons/GCP.CLOUD_LOAD_BALANCING.svg',
  'GCP.PUS.Topic': '/images/visualizer/resource-icons/GCP.PUBSUB.svg',
  'GCP.PUS.Subscription': '/images/visualizer/resource-icons/GCP.PUBSUB.svg',
  'GCP.CLR.Service': '/images/visualizer/resource-icons/GCP.CLOUD_RUN.svg',
  'GCP.DNS.Zone': '/images/visualizer/resource-icons/GCP.CLOUD_DNS.svg',
  'GCP.DNS.Policy': '/images/visualizer/resource-icons/GCP.CLOUD_DNS.svg',
  'GCP.ASI.Resource': '/images/visualizer/resource-icons/GCP.ASSET_INVENTORY.svg',
  'GCP.EC.Contact': '',
  'GCP.CMS.RedisInstance': '/images/visualizer/resource-icons/GCP.MEMORY_STORE.svg',
  'GCP.CLO.Logging': '/images/visualizer/resource-icons/GCP.CLOUD_LOGGING.svg',
  'GCP.SQL.Instance': '/images/visualizer/resource-icons/GCP.CLOUD_SQL.svg',
  'GCP.DPR.Cluster': '/images/visualizer/resource-icons/GCP.DATAPROC.svg',
  'GCP.SU.ApiKeys': '/images/visualizer/resource-icons/GCP.SU.ApiKeys.svg',
  'GCP.CDN.BackendBucket': '/images/visualizer/resource-icons/GCP.CDN.BackendBucket.svg',
  'GCP.SecretManager.Secret': secret_manager_rounded,
  'GCP.CertificateManager.Certificate': certificate_manager_rounded,
  'GCP.CloudMonitoring.Alert': cloud_monitoring,
  'GCP.CloudArmor.SecurityPolicy': '/images/visualizer/service-icons/GCP_Cloud_Armor.svg',
  'GCP.GAR.Repository': '/images/visualizer/resource-icons/GCP.ARTIFACT_REGISTRY.svg',
  'GCP.GAR.Image': '/images/visualizer/resource-icons/GCP.ARTIFACT_REGISTRY.svg',
  'GCP.Organizations.Account': '',
  'GCP.GCE.Instance_NetworkTag': '/images/visualizer/resource-icons/GCP.GCE.Instance_NetworkTag.svg',
  'GCP.GCE.Instance_NetworkInterface': '/images/visualizer/resource-icons/GCP.GCE.Instance_NetworkInterface.svg',
  'GCP.GCE.Instance_NicAccessConfig': '/images/visualizer/resource-icons/GCP.GCE.Instance_NicAccessConfig.svg',
  'GCP.GCE.Instance_IpRule': '/images/visualizer/resource-icons/GCP.GCE.Instance_IpRule.svg',
  'GCP.STO.Bucket_Label': '/images/visualizer/resource-icons/GCP.STO.Bucket_Label.svg',
  'GCP.SU.Services': '/images/visualizer/resource-icons/GCP.SU.Service.svg',
  'GCP.GKE.ApiService': gcp_gke,
  'GCP.GKE.Audit': gcp_gke,
  'GCP.GKE.ClusterNodeMonitor': gcp_gke,
  'GCP.GKE.ClusterPodMonitoring': gcp_gke,
  'GCP.GKE.ClusterRole': gcp_gke,
  'GCP.GKE.ClusterRoleBinding': gcp_gke,
  'GCP.GKE.ComponentStatus': gcp_gke,
  'GCP.GKE.ConfigMap': gcp_gke,
  'GCP.GKE.Container': gcp_gke,
  'GCP.GKE.ControllerRevision': gcp_gke,
  'GCP.GKE.CsiDriver': gcp_gke,
  'GCP.GKE.CsiNode': gcp_gke,
  'GCP.GKE.CustomResourceDefinition': gcp_gke,
  'GCP.GKE.DaemonSet': gcp_gke,
  'GCP.GKE.Deployment': gcp_gke,
  'GCP.GKE.EndpointSlice': gcp_gke,
  'GCP.GKE.Endpoints': gcp_gke,
  'GCP.GKE.Event': gcp_gke,
  'GCP.GKE.FlowSchema': gcp_gke,
  'GCP.GKE.HorizontalPodAutoscaler': gcp_gke,
  'GCP.GKE.Lease': gcp_gke,
  'GCP.GKE.MutatingWebhookConfiguration': gcp_gke,
  'GCP.GKE.Namespace': gcp_gke,
  'GCP.GKE.OperatorConfig': gcp_gke,
  'GCP.GKE.Pod': gcp_gke,
  'GCP.GKE.PriorityClass': gcp_gke,
  'GCP.GKE.PriorityLevelConfiguration': gcp_gke,
  'GCP.GKE.RBAC': gcp_gke,
  'GCP.GKE.ReplicaSet': gcp_gke,
  'GCP.GKE.ResourceQuota': gcp_gke,
  'GCP.GKE.Role': gcp_gke,
  'GCP.GKE.Group': gcp_gke,
  'GCP.GKE.PodMetrics': gcp_gke,
  'GCP.GKE.User': gcp_gke,
  'GCP.GKE.RoleBinding': gcp_gke,
  'GCP.GKE.RuntimeClass': gcp_gke,
  'GCP.GKE.Secret': gcp_gke,
  'GCP.GKE.Service': gcp_gke,
  'GCP.GKE.ServiceAccount': gcp_gke,
  'GCP.GKE.StatefulSet': gcp_gke,
  'GCP.GKE.StorageClass': gcp_gke,
  'GCP.GKE.ValidatingWebhookConfiguration': gcp_gke,
  'GCP.GKE.Version': gcp_gke,
  'GCP.GKE.ClusterNodeMonitoring': gcp_gke,
  'GCP.GKE.Job':  gcp_gke,
  'GCP.GKE.CronJob': gcp_gke,
  'GCP.GKE.Image': gcp_gke,
  'GCP.GKE.PersistentVolumeClaim': gcp_gke,
  'GCP.GKE.PersistentVolume': gcp_gke,
  'GCP.GKE.PodDisruptionBudget': gcp_gke,
  'GCP.GKE.CertificateSigningRequest': gcp_gke,
  'GCP.GKE.NetworkPolicy': gcp_gke,
  'GCP.GKE.PodMonitoring': gcp_gke,
  'GCP.APIGateway.Gateway': gcp_api_gateway,

  'Azure.AAD.User': '/images/visualizer/resource-icons/azure_icons/Azure.AAD.User.png',
  'Azure.AAD.Group': '/images/visualizer/resource-icons/azure_icons/Azure.AAD.groups.png',
  'Azure.AAD.ServicePrincipal': '/images/visualizer/resource-icons/azure_icons/Azure.AAD.ServicePrincipal.png',
  'Azure.AAD.Application': '/images/visualizer/resource-icons/azure_icons/Azure.AAD.Application.png',
  'Azure.AppService.WebApp': '/images/visualizer/resource-icons/azure_icons/Azure.AppService.WebApp.png',
  'Azure.Network.NetworkSecurityGroup':
    '/images/visualizer/resource-icons/azure_icons/Azure.Network.NetworkSecurityGroup.png',
  'Azure.Network.Watcher': '/images/visualizer/resource-icons/azure_icons/Azure.Network.Watcher.png',
  'Azure.Network.ApplicationSecurityGroup':
    '/images/visualizer/resource-icons/azure_icons/Azure.Network.ApplicationSecurityGroup.png',
  'Azure.Network.SecurityGroup':
    '/images/visualizer/resource-icons/azure_icons/Azure.Network.ApplicationSecurityGroup.png',
  'Azure.Network.VirtualNetwork': '/images/visualizer/resource-icons/azure_icons/Azure.Network.VirtualNetwork.png',
  'Azure.Network.NetworkWatcherFlowLog':
    '/images/visualizer/resource-icons/azure_icons/Azure.Network.NetworkWatcherFlowLog.png',
  'Azure.Network.ApplicationGateway':
    '/images/visualizer/resource-icons/azure_icons/Azure.Network.ApplicationGateway.png',
  'Azure.Network.NetworkSecurityRule':
    '/images/visualizer/resource-icons/azure_icons/Azure.Network.NetworkSecurityRule.png',
  'Azure.Network.NetworkInterface': '/images/visualizer/resource-icons/azure_icons/Azure.Network.NetworkInterface.png',
  'Azure.SecurityCenter.AutoProvisioning':
    '/images/visualizer/resource-icons/azure_icons/Azure.SecurityCenter.AutoProvisioning.png',
  'Azure.SecurityCenter.AutoProvisioningSettings':
    '/images/visualizer/resource-icons/azure_icons/Azure.SecurityCenter.AutoProvisioning.png',
  'Azure.SecurityCenter.Contact': '/images/visualizer/resource-icons/azure_icons/Azure.SecurityCenter.Contact.png',
  'Azure.SecurityCenter.Pricing': '/images/visualizer/resource-icons/azure_icons/Azure.SecurityCenter.Pricing.png',
  'Azure.Storage.Account': '/images/visualizer/resource-icons/azure_icons/Azure.Storage.Account.png',
  'Azure.Storage.Container': '/images/visualizer/resource-icons/azure_icons/Azure.Storage.Container.png',
  'Azure.Storage.Queue': '/images/visualizer/resource-icons/azure_icons/Azure.Storage.Queue.png',
  'Azure.Storage.Tables': '/images/visualizer/resource-icons/azure_icons/Azure.Storage.Tables.png',
  'Azure.Storage.AccountNetworkRules':
    '/images/visualizer/resource-icons/azure_icons/Azure.Storage.AccountNetworkRules.png',
  'Azure.Storage.BlobContainer': '/images/visualizer/resource-icons/azure_icons/Azure.Storage.Account.png',
  'Azure.VirtualMachine.Disk': '/images/visualizer/resource-icons/azure_icons/Azure.VirtualMachine.Disk.png',
  'Azure.VirtualMachine.Instance': '/images/visualizer/resource-icons/azure_icons/Azure.VirtualMachine.Instance.png',
  'Azure.VirtualMachine.Snapshot': '/images/visualizer/resource-icons/azure_icons/Azure.VirtualMachine.Snapshot.png',
  'Azure.VirtualMachine.Image': '/images/visualizer/resource-icons/azure_icons/Azure.VirtualMachine.Image.png',
  'Azure.SQLDatabase.Server': '/images/visualizer/resource-icons/azure_icons/Azure.SQLDatabase.Server.png',
  'Azure.SQLDatabase.Database': '/images/visualizer/resource-icons/azure_icons/Azure.SQLDatabase.Database.png',
  'Azure.KeyVault.Vault': '/images/visualizer/resource-icons/azure_icons/Azure.KeyVault.Vault.png',
  'Azure.KeyVault.Secret': '/images/visualizer/resource-icons/azure_icons/Azure.KeyVault.Secret.png',
  'Azure.RBAC.Role': '/images/visualizer/resource-icons/azure_icons/Azure.RBAC.Role.png',
  'Azure.RBAC.RoleAssignments': '/images/visualizer/resource-icons/azure_icons/Azure.RBAC.RoleAssignments.png',
  'Azure.BackupVault.Vault': '/images/visualizer/resource-icons/azure_icons/Azure.BackupVault.Vault.png',
  'Azure.CosmosDB.Account': '/images/visualizer/resource-icons/azure_icons/Azure.CosmosDB.Account.png',
  'Azure.MySQL.Server': '/images/visualizer/resource-icons/azure_icons/Azure.MySQL.Server.png',
  'Azure.Redis.Cache': '/images/visualizer/resource-icons/azure_icons/Azure.Redis.Cache.png',
  'Azure.RecoveryVault.Vault': '/images/visualizer/resource-icons/azure_icons/Azure.RecoveryVault.Vault.png',
  'Azure.ElasticSAN.Network': '/images/visualizer/resource-icons/azure_icons/Azure.ElasticSAN.Network.png',
  'Azure.PostgreSQL.Server': '/images/visualizer/resource-icons/azure_icons/Azure.PostgreSQL.Server.png',
  'Azure.Monitor.DiagnosticSetting': azure_monitor,
  'Azure.Monitor.LogAlert': azure_monitor,
  'Azure.Monitor.LogProfile': azure_monitor,
  'Azure.Monitor.ResourceLogging': azure_monitor,

  Issues: '/images/visualizer/resource-icons/issues.svg',
  ImagePush: '/images/visualizer/resource-icons/imagePush.png',
  Baseline: '/images/visualizer/resource-icons/baseLine.png',
  Process: '/images/visualizer/resource-icons/process.png',
  Fingerprint: '/images/visualizer/resource-icons/fingerprint.svg',
  Alert: '/images/visualizer/resource-icons/alert.svg',

  'DockerHub.Repository': '/images/visualizer/resource-icons/DockerHub.Repository.svg',
  'DockerHub.Image': '/images/visualizer/resource-icons/DockerHub.Image.svg',


};

export default ICONS;
